import React from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { Button } from './common'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    notFound: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    notFoundTitle: {
        fontSize: 100,
        fontWeight: 'bold'
    },
    notFoundDescription: {
        fontSize: 17,
        marginBottom: 20
    }
}))

function ErrorPage(props) {
    const classes = useStyles()

    const goHome = () => {
        props.history.push('/')
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.notFound}>
                <div className={classes.notFoundTitle}>
                    404
                </div>
                <div className={classes.notFoundDescription}>
                    Page not found..
                </div>
                <div>
                    <Button
                        onClick={goHome}
                    >
                        Go Home
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default withRouter(ErrorPage)
